import axios from 'axios';

export default {
  namespaced: true,
  state: {
    ysumUserData: 0,
    agoData: {
      newUser: 0,
      cancelUser: 0
    }
  },
  mutations: {
    // yesterdaySumUserData(state, { data }) {
    //   state.ysumUserData = data && data.cumulateUser;
    // },
    // agoDaysUserData(state, { agoData }) {
    //   agoData && (state.agoData = agoData);
    // },
  },
  actions: {
    userData({ commit }, params) {
      return axios.get('/wxdata/ajax/userData', {
        params: params,
        cache: true,
      }).then((data) => {
        // commit({ type: 'yesterdaySumUserData', data: data.data[0] });
        return data;
      });
    },
    agoDaysUserData({ commit }, params) {
      return axios.get('/wxdata/ajax/agoDaysUserData', {
        params: params,
        cache: true,
      }).then((data) => {
        // commit({ type: 'agoDaysUserData', agoData: data.data[0] });
        return data;
      });
    }
  },
};
